import { Box, Typography } from '@mui/material';
import Button from 'components/Common/Button';

export default function Billing() {
  return (
    <Box>
      <Typography variant='h6' mb={3}>
        Billing
      </Typography>
      <Box bgcolor='#fff' padding={3} border='1px solid #ECECEC' borderRadius={1}>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Box>
            <Typography variant='h6' mb={0.5}>
              Agency Plan
            </Typography>
            <Typography color='secondary'>This agency plan offers multiple benefits.</Typography>
          </Box>
          <Box>
            <Typography variant='h5' mb={0.5} fontWeight={500} display='flex' justifyContent='end'>
              $630
            </Typography>
            <Typography color='secondary' variant='body2'>
              September 2024( Last Invoice)
            </Typography>
          </Box>
        </Box>
        <Box border='1px solid #ECECEC' borderRadius={1} my={3}>
          <Box display='flex' padding='16px 24px' justifyContent='space-between' borderBottom='1px solid #ECECEC'>
            <Typography color='secondary' variant='body2' fontWeight={500}>
              PLAN USAGE
            </Typography>
            <Typography color='secondary' variant='body2' fontWeight={500}>
              EST. COST
            </Typography>
          </Box>
          <Box margin={3}>
            <Box
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              pb={2}
              borderBottom='1px solid #ECECEC'
            >
              <Typography>Plan Cost</Typography>
              <Typography>$499.00</Typography>
            </Box>
            <Box
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              py={2}
              borderBottom='1px solid #ECECEC'
            >
              <Typography>Agent’s Commission </Typography>
              <Typography>(22*9)=$198.00</Typography>
            </Box>
            <Box
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              py={2}
              borderBottom='1px solid #ECECEC'
            >
              <Typography>Tax</Typography>
              <Typography>$0.00</Typography>
            </Box>
            <Box display='flex' justifyContent='space-between' alignItems='center' mt={2}>
              <Typography variant='h6' fontWeight={500}>
                Total Payable
              </Typography>
              <Typography variant='h6' fontWeight={500}>
                $697.00
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box display='flex' justifyContent='space-between' alignItems='center' pt={3} borderTop='1px solid #ECECEC'>
          <Typography>Payment account *** 3262</Typography>
          <Box display='flex' gap={2}>
            <Button variant='outlined' sx={{ color: '#777', border: '1px solid #ECECEC' }}>
              Cancel Subscription
            </Button>
            <Button variant='contained'>Update Now</Button>
          </Box>
        </Box>
        <Typography variant='h6' my={3}>
          Invoices
        </Typography>
        {/* <DataTable
          data={teamMembers?.data}
          columns={columns(deleteTeamMember)}
          isHeaderSticky={true}
          isLoading={isLoading}
        /> */}
      </Box>
    </Box>
  );
}

// const columns = (): ColumnDef<TeamMember>[] => [
//   {
//     header: 'STATUS',
//     accessorKey: 'STATUS'
//   },
//   {
//     header: 'DATE',
//     accessorKey: 'DATE'
//   },
//   {
//     header: 'AMOUNT',
//     accessorKey: 'AMOUNT'
//   },
//   {
//     header: 'PAYMENT',
//     accessorKey: 'PAYMENT'
//   },
//   {
//     header: 'DETAILS',
//     cell: (info) => (
//       <Box display='flex' gap={1}>
//         Invoices
//       </Box>
//     )
//   }
// ];
